module.exports = __webpack_public_path__ + "media/images/modal-gloss-7d2aab4db2f4758ad052077dde124507d2f84e8c7a0d882853b271b8ea189671.png";